export default function getScrollbarSize() {
  var isCustomScrollbar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '1337px';
  scrollDiv.style.height = '1337px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.left = '-9999px';
  scrollDiv.style.overflow = 'scroll';
  var isBodyCustomScroll = document.body.classList.contains('body-veneer-scrollbar');
  if (isCustomScrollbar || isBodyCustomScroll) {
    var style = document.createElement('style');
    style.textContent = '.scroll-size::-webkit-scrollbar { width: 8px; } .scroll-size { scrollbar-width: thin; }';
    document.head.appendChild(style);
    scrollDiv.classList.add('scroll-size');
  }
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return Math.abs(scrollbarWidth);
}